function normalizeFacetText(text) {
  return String(text || '')
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/ß/g, 'ss');
}

function parseSizeFilterLabel(label) {
  const rawLabel = String(label || '').trim();
  const numbers = rawLabel.match(/\d+/g);
  const startsWithNumber = /^\d/.test(rawLabel);

  if (!numbers || !numbers.length) {
    return {
      group: 2,
      from: Number.MAX_SAFE_INTEGER,
      to: Number.MAX_SAFE_INTEGER,
      label: rawLabel,
    };
  }

  const from = Number(numbers[0]);
  const to = Number(numbers[1] || numbers[0]);

  return {
    group: startsWithNumber ? 0 : 1,
    from,
    to,
    label: rawLabel,
  };
}

function getFacetItemVisibleLabel(item) {
  return (
    item.getAttribute('data-facet-value-label') ||
    item.querySelector('.facet-checkbox__text-label')?.textContent ||
    item.querySelector('label[title]')?.getAttribute('title') ||
    item.textContent ||
    ''
  );
}

function isSizeFacetList(list) {
  const input = list.querySelector('input[name]');
  if (!input) return false;

  const name = normalizeFacetText(input.getAttribute('name'));
  if (name.includes('grosse') || name.includes('groesse') || name.includes('size')) return true;

  const filter = list.closest('.js-filter');
  const summaryText = filter ? normalizeFacetText(filter.textContent) : '';
  return summaryText.includes('grosse') || summaryText.includes('groesse') || summaryText.includes('size');
}

function sortSizeFacetValues(root = document) {
  root.querySelectorAll('.facets__list, .mobile-facets__list').forEach((list) => {
    if (!isSizeFacetList(list)) return;

    const items = Array.from(list.children).filter((item) => item.matches('li'));
    if (items.length < 2) return;

    items
      .sort((itemA, itemB) => {
        const labelA = parseSizeFilterLabel(getFacetItemVisibleLabel(itemA));
        const labelB = parseSizeFilterLabel(getFacetItemVisibleLabel(itemB));

        if (labelA.group !== labelB.group) return labelA.group - labelB.group;
        if (labelA.from !== labelB.from) return labelA.from - labelB.from;
        if (labelA.to !== labelB.to) return labelA.to - labelB.to;
        return labelA.label.localeCompare(labelB.label, 'de', { numeric: true, sensitivity: 'base' });
      })
      .forEach((item) => list.appendChild(item));
  });
}

function sortClosestSizeFacet(target) {
  const facetDetails = target.closest('.js-filter');

  if (facetDetails) {
    sortSizeFacetValues(facetDetails);
  }
}

function initMobileSortToggles(root = document) {
  function updateMobileSortSelection(input) {
    const sortDetails = input.closest('.mobile-facets__sort-details');
    if (!sortDetails) return;

    sortDetails.querySelectorAll('.mobile-facets__sort-option').forEach((option) => {
      option.classList.toggle('is-active', option.contains(input));
    });

    const current = sortDetails.querySelector('.mobile-facets__sort-current');
    const optionText = input.closest('.mobile-facets__sort-option')?.querySelector('span:last-child')?.textContent;
    if (current && optionText) current.textContent = optionText.trim();
  }

  function toggleMobileSort(toggle) {
    const sortDetails = toggle.closest('.mobile-facets__sort-details');
    const options = sortDetails ? sortDetails.querySelector('.mobile-facets__sort-options') : null;
    if (!sortDetails || !options) return;

    const isOpen = sortDetails.classList.toggle('is-open');
    toggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
    options.hidden = !isOpen;
  }

  root.querySelectorAll('.mobile-facets__sort-details').forEach((sortDetails) => {
    if (sortDetails.dataset.mobileSortDetailsBound === 'true') return;

    sortDetails.dataset.mobileSortDetailsBound = 'true';
    sortDetails.addEventListener('click', (event) => {
      event.stopPropagation();
    });
  });

  root.querySelectorAll('[data-mobile-sort-toggle]').forEach((toggle) => {
    if (toggle.dataset.mobileSortBound === 'true') return;

    toggle.dataset.mobileSortBound = 'true';
    toggle.addEventListener('click', (event) => {
      event.preventDefault();
      event.stopImmediatePropagation();
      toggleMobileSort(toggle);
    }, true);

    toggle.addEventListener('click', (event) => {
      event.preventDefault();
      event.stopPropagation();
    });
  });

  root.querySelectorAll('.mobile-facets__sort-option').forEach((option) => {
    if (option.dataset.mobileSortOptionBound === 'true') return;

    option.dataset.mobileSortOptionBound = 'true';
    option.addEventListener('click', (event) => {
      event.preventDefault();
      event.stopImmediatePropagation();

      const input = option.querySelector('input[name="sort_by"]');
      if (!input) return;

      input.checked = true;
      updateMobileSortSelection(input);
    }, true);
  });

  root.querySelectorAll('.mobile-facets__sort-option input[name="sort_by"]').forEach((input) => {
    if (input.dataset.mobileSortInputBound === 'true') return;

    input.dataset.mobileSortInputBound = 'true';

    ['click', 'input', 'change'].forEach((eventName) => {
      input.addEventListener(eventName, (event) => {
        event.stopPropagation();
      }, true);
    });

    input.addEventListener('click', (event) => {
      event.stopPropagation();
    });

    input.addEventListener('input', (event) => {
      event.stopPropagation();
    });

    input.addEventListener('change', (event) => {
      event.stopPropagation();
      updateMobileSortSelection(input);
    });
  });
}

/* Mobile filter drawer: its content is kept inert in <template data-mobile-facets> (snippets/facets.liquid)
   until first opened, because it holds thousands of elements most visitors never need. */
function expandMobileFacets() {
  const template = document.querySelector('template[data-mobile-facets]');
  if (!template) return false;

  const drawer = template.closest('menu-drawer');
  const nodes = Array.from(template.content.children);
  template.replaceWith(template.content);

  // What MenuDrawer's constructor and the page-load initialisers would have done for this content.
  if (drawer && typeof drawer.onSummaryClick === 'function') {
    nodes.forEach((node) => {
      node.querySelectorAll('summary').forEach((summary) =>
        summary.addEventListener('click', drawer.onSummaryClick.bind(drawer))
      );
      node
        .querySelectorAll(
          'button:not(.localization-selector):not(.country-selector__close-button):not(.country-filter__reset-button)'
        )
        .forEach((button) => button.addEventListener('click', drawer.onCloseButtonClick.bind(drawer)));
    });
  }
  nodes.forEach((node) => initMobileSortToggles(node));
  sortSizeFacetValues();
  initMobileActiveFilterSummary();
  if (window.PriceRangeV2 && typeof window.PriceRangeV2.initAll === 'function') window.PriceRangeV2.initAll();
  document.dispatchEvent(new CustomEvent('mobile-facets:expanded', { detail: { nodes } }));
  return true;
}

(function bindMobileFacetsExpansion() {
  const opener = '.mobile-facets__disclosure > summary, [data-open-mobile-facets], .mobile-facets__open';
  const expandIfOpener = (event) => {
    if (event.target instanceof Element && event.target.closest(opener)) expandMobileFacets();
  };
  ['pointerdown', 'touchstart', 'click', 'keydown'].forEach((type) =>
    document.addEventListener(type, expandIfOpener, { capture: true, passive: true })
  );
  // Fallback for any other way the drawer gets opened.
  document.addEventListener(
    'toggle',
    (event) => {
      if (event.target.matches && event.target.matches('.mobile-facets__disclosure') && event.target.open) {
        expandMobileFacets();
      }
    },
    true
  );
})();

function isMobileFacetSubmit(event) {
  return event?.type === 'submit' && !!event.target?.closest('#FacetFiltersFormMobile');
}

function closeMobileFacetsDrawer() {
  const disclosure = document.querySelector('.mobile-facets__disclosure');
  const drawer = disclosure ? disclosure.closest('menu-drawer') : null;

  if (drawer && typeof drawer.closeMenuDrawer === 'function' && disclosure?.hasAttribute('open')) {
    drawer.closeMenuDrawer(new Event('click'));
  }

  if (disclosure) {
    disclosure.removeAttribute('open');
    disclosure.classList.remove('menu-opening');

    const summary = disclosure.querySelector(':scope > summary');
    if (summary) summary.setAttribute('aria-expanded', 'false');

    disclosure.querySelectorAll('details[open]').forEach((details) => {
      details.removeAttribute('open');
      details.classList.remove('menu-opening');
    });

    disclosure.querySelectorAll('.submenu-open').forEach((submenu) => {
      submenu.classList.remove('submenu-open');
    });
  }

  document.body.classList.remove(
    'overflow-hidden',
    'overflow-hidden-mobile',
    'overflow-hidden-tablet',
    'overflow-hidden-desktop'
  );

  if (typeof removeTrapFocus === 'function') {
    try {
      removeTrapFocus();
    } catch (e) {}
  }
}

function getMobileFacetLabel(details) {
  const summaryLabel = details.querySelector(':scope > summary span');
  return (summaryLabel?.textContent || '').replace(/\s+/g, ' ').trim();
}

function mobileFacetHasSelection(details) {
  if (details.classList.contains('mobile-facets__sort-details')) return false;

  const checkedInput = details.querySelector('input[type="checkbox"]:checked, input[type="radio"]:checked');
  if (checkedInput) return true;

  const priceInput = Array.from(details.querySelectorAll('input[name][type="text"], input[name][type="number"]')).find(
    (input) => String(input.value || '').trim() !== ''
  );

  return !!priceInput;
}

function updateMobileActiveFilterSummary(root = document) {
  const form = root.querySelector?.('#FacetFiltersFormMobile') || document.getElementById('FacetFiltersFormMobile');
  if (!form) return;

  const activeList = form.querySelector('.mobile-facets__active-list');
  if (!activeList) return;

  const activeLabels = Array.from(form.querySelectorAll('.mobile-facets__details.js-filter'))
    .filter(mobileFacetHasSelection)
    .map(getMobileFacetLabel)
    .filter(Boolean);

  activeList.innerHTML = '';

  if (!activeLabels.length) {
    const empty = document.createElement('span');
    empty.className = 'mobile-facets__active-filter mobile-facets__active-filter--empty';
    const S = (window.gwaStrings && window.gwaStrings.facets) || {};
    empty.textContent = S.no_filter_selected || 'Kein Filter ausgewählt';
    activeList.appendChild(empty);
    return;
  }

  activeLabels.forEach((label) => {
    const item = document.createElement('span');
    item.className = 'mobile-facets__active-filter';
    item.textContent = label;
    activeList.appendChild(item);
  });
}

function initMobileActiveFilterSummary(root = document) {
  const form = root.querySelector?.('#FacetFiltersFormMobile') || document.getElementById('FacetFiltersFormMobile');
  if (!form || form.dataset.mobileActiveSummaryBound === 'true') {
    updateMobileActiveFilterSummary(root);
    return;
  }

  form.dataset.mobileActiveSummaryBound = 'true';
  form.addEventListener('input', () => updateMobileActiveFilterSummary());
  form.addEventListener('change', () => updateMobileActiveFilterSummary());
  updateMobileActiveFilterSummary(root);
}

function initDesktopSortOptions(root = document) {
  root.querySelectorAll('.facets__sort-disclosure .facets__label').forEach((label) => {
    if (label.dataset.desktopSortBound === 'true') return;

    label.dataset.desktopSortBound = 'true';
    label.addEventListener(
      'click',
      (event) => {
        const input = label.querySelector('input[name="sort_by"]');
        const form = label.closest('form');
        const disclosure = label.closest('.facets__sort-disclosure');

        if (!input || !form) return;

        event.preventDefault();
        event.stopPropagation();

        if (!input.checked) {
          input.checked = true;
        }

        input.dispatchEvent(new Event('input', { bubbles: true }));

        if (disclosure) {
          disclosure.removeAttribute('open');
        }
      },
      true
    );
  });
}

class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();

    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 500);

    this._isBound = false;
    this._boundSubmitHandler = this.debouncedOnSubmit;
    this._boundDirectSubmitHandler = (event) => {
      event.preventDefault();
      this.onSubmitHandler(event);
    };
  }

  connectedCallback() {
    if (this._isBound) return;
    this._isBound = true;

    const facetForm = this.querySelector('form');
    if (facetForm) {
      facetForm.addEventListener('input', this._boundSubmitHandler);
      facetForm.addEventListener('change', this._boundSubmitHandler);
      facetForm.addEventListener('submit', this._boundDirectSubmitHandler);
    }

    const facetWrapper = this.querySelector('#FacetsWrapperDesktop');
    if (facetWrapper) {
      facetWrapper.addEventListener('keyup', onKeyUpEscape);
    }

    initMobileActiveFilterSummary(this);
    initDesktopSortOptions(this);
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    };

    window.addEventListener('popstate', onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.classList.toggle('disabled', disable);
    });
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();
    if (!sections.length) return;

    const countContainer = document.getElementById('ProductCount');
    const countContainerDesktop = document.getElementById('ProductCountDesktop');
    const loadingSpinners = document.querySelectorAll(
      '.facets-container .loading__spinner, facet-filters-form .loading__spinner'
    );

    loadingSpinners.forEach((spinner) => spinner.classList.remove('hidden'));

    const productGridContainer = document.getElementById('ProductGridContainer');
    const collection = productGridContainer ? productGridContainer.querySelector('.collection') : null;

    if (collection) {
      collection.classList.add('loading');
    }

    if (countContainer) countContainer.classList.add('loading');
    if (countContainerDesktop) countContainerDesktop.classList.add('loading');

    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = (element) => element.url === url;

      if (FacetFiltersForm.filterData.some(filterDataUrl)) {
        FacetFiltersForm.renderSectionFromCache(filterDataUrl, event);
      } else {
        FacetFiltersForm.renderSectionFromFetch(url, event);
      }
    });

    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
  }

  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        const html = responseText;
        FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url }];

        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html);
        FacetFiltersForm.renderProductCount(html);

        if (typeof initializeScrollAnimationTrigger === 'function') {
          try {
            initializeScrollAnimationTrigger(html.innerHTML);
          } catch (e) {}
        }
      })
      .catch(() => {});
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const cached = FacetFiltersForm.filterData.find(filterDataUrl);
    if (!cached) return;

    const html = cached.html;
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
    FacetFiltersForm.renderProductCount(html);

    if (typeof initializeScrollAnimationTrigger === 'function') {
      try {
        initializeScrollAnimationTrigger(html.innerHTML);
      } catch (e) {}
    }
  }

  static renderProductGridContainer(html) {
    const parsed = new DOMParser().parseFromString(html, 'text/html');
    const source = parsed.getElementById('ProductGridContainer');
    const target = document.getElementById('ProductGridContainer');

    if (!source || !target) return;

    target.innerHTML = source.innerHTML;

    target.querySelectorAll('.scroll-trigger').forEach((element) => {
      element.classList.add('scroll-trigger--cancel');
    });

    document.dispatchEvent(new CustomEvent('facets:updated'));
  }

  static renderProductCount(html) {
    const parsed = new DOMParser().parseFromString(html, 'text/html');

    const sourceMobile = parsed.getElementById('ProductCount');
    const sourceDesktop = parsed.getElementById('ProductCountDesktop');
    const sourceDrawerCount =
      parsed.querySelector('#FacetFiltersFormMobile .mobile-facets__count') ||
      parsed.querySelector('template[data-mobile-facets]')?.content.querySelector('.mobile-facets__count');

    const containerMobile = document.getElementById('ProductCount');
    const containerDesktop = document.getElementById('ProductCountDesktop');

    const extractShownCount = (node) => {
      if (!node) return '';
      const txt = (node.textContent || '').replace(/\s+/g, ' ').trim();
      const matches = txt.match(/\d+/g);
      if (!matches || !matches.length) return txt;
      return matches[matches.length - 1];
    };

    let mobileCount = extractShownCount(sourceMobile || sourceDesktop);
    let desktopCount = extractShownCount(sourceDesktop || sourceMobile);
    let drawerCount = extractShownCount(sourceDrawerCount) || mobileCount;

    if ((!desktopCount || desktopCount === '0') && mobileCount && mobileCount !== '0') {
      desktopCount = mobileCount;
    }

    if ((!mobileCount || mobileCount === '0') && desktopCount && desktopCount !== '0') {
      mobileCount = desktopCount;
    }

    if ((!drawerCount || drawerCount === '0') && mobileCount && mobileCount !== '0') {
      drawerCount = mobileCount;
    }

    if (containerMobile) {
      containerMobile.textContent = mobileCount;
      containerMobile.classList.remove('loading');
    }

    if (containerDesktop) {
      containerDesktop.textContent = desktopCount;
      containerDesktop.classList.remove('loading');
    }

    document.querySelectorAll('.mobile-facets__count').forEach((el) => {
      el.textContent = drawerCount;
      el.classList.remove('loading');
    });

    const loadingSpinners = document.querySelectorAll(
      '.facets-container .loading__spinner, facet-filters-form .loading__spinner'
    );
    loadingSpinners.forEach((spinner) => spinner.classList.add('hidden'));
  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');

    // Mobile drawer never opened: just refresh its inert template. Once opened, render it like before.
    const mobileTemplate = document.querySelector('template[data-mobile-facets]');
    const fetchedMobileTemplate = parsedHTML.querySelector('template[data-mobile-facets]');
    if (mobileTemplate) {
      if (fetchedMobileTemplate) mobileTemplate.innerHTML = fetchedMobileTemplate.innerHTML;
    } else if (fetchedMobileTemplate) {
      fetchedMobileTemplate.replaceWith(fetchedMobileTemplate.content);
    }

    const facetDetailsElementsFromFetch = parsedHTML.querySelectorAll(
      '#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter'
    );
    const facetDetailsElementsFromDom = document.querySelectorAll(
      '#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter'
    );

    const mobileDrawerDetails = document.querySelector('.mobile-facets__disclosure');
    const wasMobileDrawerOpen = mobileDrawerDetails ? mobileDrawerDetails.hasAttribute('open') : false;
    const isMobileSubmit = isMobileFacetSubmit(event);

    const activeMobileFilter = event?.target?.closest('#FacetFiltersFormMobile .js-filter');
    const activeMobileFilterId = activeMobileFilter ? activeMobileFilter.id : null;
    const activeMobileSubmenu = activeMobileFilterId ? document.getElementById(activeMobileFilterId) : null;
    const wasActiveMobileFilterOpen = activeMobileSubmenu ? activeMobileSubmenu.hasAttribute('open') : false;

    const activeDesktopFilter = event?.target?.closest('#FacetFiltersForm .js-filter');
    const activeDesktopFilterId = activeDesktopFilter ? activeDesktopFilter.id : null;
    const wasActiveDesktopFilterOpen = activeDesktopFilter
      ? activeDesktopFilter.hasAttribute('open')
      : false;

    Array.from(facetDetailsElementsFromDom).forEach((currentElement) => {
      if (!Array.from(facetDetailsElementsFromFetch).some(({ id }) => currentElement.id === id)) {
        currentElement.remove();
      }
    });

    const matchesId = (element) => {
      const jsFilter = event && event.target ? event.target.closest('.js-filter') : undefined;
      return jsFilter ? element.id === jsFilter.id : false;
    };

    const facetsToRender = Array.from(facetDetailsElementsFromFetch).filter((element) => !matchesId(element));
    const countsToRender = Array.from(facetDetailsElementsFromFetch).find(matchesId);

    facetsToRender.forEach((elementToRender, index) => {
      if (!elementToRender.id) return;
      const currentElement = document.getElementById(elementToRender.id);

      if (currentElement) {
        currentElement.innerHTML = elementToRender.innerHTML;
      } else {
        if (index > 0) {
          const { className: previousElementClassName, id: previousElementId } = facetsToRender[index - 1];
          if (elementToRender.className === previousElementClassName) {
            const previousElement = document.getElementById(previousElementId);
            if (previousElement) {
              previousElement.after(elementToRender);
              return;
            }
          }
        }

        if (elementToRender.parentElement && elementToRender.parentElement.id) {
          try {
            const parentTarget = document.querySelector(`#${CSS.escape(elementToRender.parentElement.id)} .js-filter`);
            if (parentTarget) {
              parentTarget.before(elementToRender);
            }
          } catch (e) {}
        }
      }
    });

    FacetFiltersForm.renderActiveFacets(parsedHTML);
    FacetFiltersForm.renderAdditionalElements(parsedHTML);

    if (typeof initFacetOverflow === 'function') initFacetOverflow();

    if (countsToRender && event && event.target) {
      const closestFilter = event.target.closest('.js-filter');
      const closestJSFilterID = closestFilter ? closestFilter.id : null;

      if (closestJSFilterID) {
        FacetFiltersForm.renderCounts(countsToRender, closestFilter);
        FacetFiltersForm.renderMobileCounts(countsToRender, document.getElementById(closestJSFilterID));

        const newFacetDetailsElement = document.getElementById(closestJSFilterID);
        if (newFacetDetailsElement) {
          const isMobileFacet = newFacetDetailsElement.classList.contains('mobile-facets__details');

          const newElementSelector = isMobileFacet
            ? '.mobile-facets__close-button'
            : '.facets__summary';

          const newElementToActivate = newFacetDetailsElement.querySelector(newElementSelector);
          const isTextInput = event.target.matches('input[type="text"], input[type="number"]');

          if (newElementToActivate && isMobileFacet && !isTextInput) {
            newElementToActivate.focus();
          }
        }
      }
    }

    if (wasMobileDrawerOpen && mobileDrawerDetails && !isMobileSubmit) {
      mobileDrawerDetails.setAttribute('open', '');
    }

    if (activeMobileFilterId && wasActiveMobileFilterOpen && !isMobileSubmit) {
      const restoredMobileFilter = document.getElementById(activeMobileFilterId);
      if (restoredMobileFilter) {
        restoredMobileFilter.setAttribute('open', '');
      }
    }

    if (activeDesktopFilterId && wasActiveDesktopFilterOpen) {
      const restoredDesktopFilter = document.getElementById(activeDesktopFilterId);
      if (restoredDesktopFilter) {
        restoredDesktopFilter.setAttribute('open', '');
      }
    }

    sortSizeFacetValues();
    initMobileActiveFilterSummary();

    if (isMobileSubmit) {
      closeMobileFacetsDrawer();
    }
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = ['.active-facets-mobile', '.active-facets-desktop'];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      const currentTarget = document.querySelector(selector);

      if (!activeFacetsElement || !currentTarget) return;
      currentTarget.innerHTML = activeFacetsElement.innerHTML;
    });

    FacetFiltersForm.toggleActiveFacets(false);
  }

  static renderAdditionalElements(html) {
    const sourceDesktopSorting = html.querySelector('.facets__topbar-sort.sorting');
    const targetDesktopSorting = document.querySelector('.facets__topbar-sort.sorting');

    if (sourceDesktopSorting && targetDesktopSorting) {
      targetDesktopSorting.innerHTML = sourceDesktopSorting.innerHTML;
      initDesktopSortOptions(targetDesktopSorting);
    }

    // Globalen "Zuruecksetzen"-Slot mitsynchronisieren (haengt von aktiven Filtern ab)
    const sourceResetSlot = html.querySelector('.facets__reset-slot');
    const targetResetSlot = document.querySelector('.facets__reset-slot');

    if (sourceResetSlot && targetResetSlot) {
      targetResetSlot.innerHTML = sourceResetSlot.innerHTML;
    }

    const mobileForm = document.getElementById('FacetFiltersFormMobile');
    const drawer = mobileForm ? mobileForm.closest('menu-drawer') : null;

    if (drawer && typeof drawer.bindEvents === 'function') {
      drawer.bindEvents();
    }

    initMobileActiveFilterSummary();
  }

  static renderCounts(source, target) {
    if (!source || !target) return;

    const targetSummary = target.querySelector('.facets__summary');
    const sourceSummary = source.querySelector('.facets__summary');

    if (sourceSummary && targetSummary) {
      targetSummary.outerHTML = sourceSummary.outerHTML;
    }

    const targetHeaderElement = target.querySelector('.facets__header');
    const sourceHeaderElement = source.querySelector('.facets__header');

    if (sourceHeaderElement && targetHeaderElement) {
      targetHeaderElement.outerHTML = sourceHeaderElement.outerHTML;
    }

    const targetWrapElement = target.querySelector('.facets-wrap');
    const sourceWrapElement = source.querySelector('.facets-wrap');

    if (sourceWrapElement && targetWrapElement) {
      const isShowingMore = Boolean(target.querySelector('show-more-button .label-show-more.hidden'));
      if (isShowingMore) {
        sourceWrapElement.querySelectorAll('.facets__item.hidden').forEach((hiddenItem) => {
          hiddenItem.classList.replace('hidden', 'show-more-item');
        });
      }

      targetWrapElement.outerHTML = sourceWrapElement.outerHTML;
    }

    const targetDisplayElement = target.querySelector('.facets__display, .facets__display-vertical');
    const sourceFooterElement = source.querySelector('.facets__dropdown-footer');
    const targetFooterElement = target.querySelector('.facets__dropdown-footer');

    if (sourceFooterElement && targetFooterElement) {
      targetFooterElement.outerHTML = sourceFooterElement.outerHTML;
    } else if (sourceFooterElement && targetDisplayElement) {
      targetDisplayElement.appendChild(sourceFooterElement.cloneNode(true));
    } else if (!sourceFooterElement && targetFooterElement) {
      targetFooterElement.remove();
    }
  }

  static renderMobileCounts(source, target) {
    if (!source || !target) return;

    const targetFacetsList = target.querySelector('.mobile-facets__list');
    const sourceFacetsList = source.querySelector('.mobile-facets__list');

    if (sourceFacetsList && targetFacetsList) {
      targetFacetsList.outerHTML = sourceFacetsList.outerHTML;
    }
  }

  static updateURLHash(searchParams) {
    history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
  }

  static getSections() {
    const productGrid = document.getElementById('product-grid');
    if (!productGrid) return [];

    return [
      {
        section: productGrid.dataset.id,
      },
    ];
  }

  createSearchParams(form) {
    const formData = new FormData(form);
    return new URLSearchParams(formData).toString();
  }

  onSubmitForm(searchParams, event) {
    FacetFiltersForm.renderPage(searchParams, event);
  }

  onSubmitHandler(event) {
    event.preventDefault();

    const targetForm = event.target.closest('form');
    if (!targetForm) return;

    const isMobile = targetForm.id === 'FacetFiltersFormMobile';
    const isPriceRange = !!event.target.closest('price-range');
    const isPriceRangeV2 = !!event.target.closest('.price-range-v2');
    const isTextInput = event.target.matches('input[type="text"], input[type="number"]');
    const isRangeInput = event.target.matches('input[type="range"]');

    if (isPriceRange || isPriceRangeV2) {
      if (event.type !== 'submit') {
        return;
      }
    } else {
      if (event.type === 'input' && (isTextInput || isRangeInput)) {
        return;
      }

      if (event.type === 'change' && isRangeInput) {
        return;
      }
    }

    if (isMobile) {
      if (event.type === 'submit') {
        closeMobileFacetsDrawer();
      }

      const searchParams = this.createSearchParams(targetForm);
      this.onSubmitForm(searchParams, event);
      return;
    }

    const forms = [];
    const desktopFiltersForm = document.getElementById('FacetFiltersForm');
    const desktopSortForm = document.getElementById('FacetSortForm');
    const drawerSortForm = document.getElementById('FacetSortDrawerForm');

    if (desktopFiltersForm) {
      forms.push(this.createSearchParams(desktopFiltersForm));
    }

    if (desktopSortForm) {
      forms.push(this.createSearchParams(desktopSortForm));
    }

    if (drawerSortForm) {
      forms.push(this.createSearchParams(drawerSortForm));
    }

    const joined = forms.filter(Boolean).join('&');
    this.onSubmitForm(joined, event);
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();

    const url =
      event.currentTarget.href.indexOf('?') === -1
        ? ''
        : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);

    FacetFiltersForm.renderPage(url);
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);

if (!customElements.get('facet-filters-form')) {
  customElements.define('facet-filters-form', FacetFiltersForm);
}
FacetFiltersForm.setListeners();

function initFacetOverflow() {
  const wrapper = document.getElementById('FacetsWrapperDesktop');
  if (!wrapper) return;

  const moreBtn = wrapper.querySelector('.facets__mehr-filter-btn');
  const actions = wrapper.querySelector('.facets__actions');
  const filters = Array.from(wrapper.querySelectorAll('.js-filter'));

  if (!filters.length) return;

  filters.forEach((f) => f.style.setProperty('display', 'inline-flex', 'important'));
  void wrapper.offsetWidth;

  const gap = 10;
  const actionsWidth = actions ? actions.offsetWidth + gap : 0;
  const availableWidth = wrapper.offsetWidth - actionsWidth;

  let usedWidth = 0;
  let overflowIndex = -1;

  for (let i = 0; i < filters.length; i++) {
    const fw = filters[i].offsetWidth + gap;
    if (overflowIndex === -1 && usedWidth + fw > availableWidth) {
      overflowIndex = i;
    }

    if (overflowIndex !== -1) {
      filters[i].classList.add('facets__filter-extra');
    } else {
      filters[i].classList.remove('facets__filter-extra');
      usedWidth += fw;
    }
  }

  filters.forEach((f) => f.style.removeProperty('display'));

  if (moreBtn) {
    moreBtn.style.display = overflowIndex !== -1 ? '' : 'none';
    if (overflowIndex === -1) {
      moreBtn.textContent = moreBtn.dataset.labelMore || 'More filters';
      const form = moreBtn.closest('.facets__form');
      if (form) form.classList.remove('facets__show-all');
    }
  }
}

function alignOpenFacetDisplays(root = document) {
  const isTablet = window.matchMedia('(min-width: 40rem) and (max-width: 64rem)').matches;

  const displays =
    root.matches && root.matches('#FacetFiltersForm .facets__disclosure')
      ? [root.querySelector('.facets__display')].filter(Boolean)
      : root.querySelectorAll('#FacetFiltersForm .facets__disclosure .facets__display');

  displays.forEach((display) => {
    display.style.removeProperty('max-width');
    display.style.removeProperty('left');
    display.style.removeProperty('right');

    if (!isTablet) return;

    const disclosure = display.closest('.facets__disclosure');
    if (!disclosure || !disclosure.open) return;

    const viewportPadding = 16;
    display.style.setProperty('max-width', `calc(100vw - ${viewportPadding * 2}px)`, 'important');
    display.style.setProperty('left', '0px', 'important');
    display.style.setProperty('right', 'auto', 'important');

    const disclosureRect = disclosure.getBoundingClientRect();
    const displayRect = display.getBoundingClientRect();
    const boundary =
      display.closest('.facets__wrapper') ||
      display.closest('.facets__filter-row') ||
      document.getElementById('FacetFiltersForm');
    const boundaryRect = boundary ? boundary.getBoundingClientRect() : null;
    const viewportWidth = window.innerWidth || document.documentElement.clientWidth;
    const minBoundaryLeft = boundaryRect ? boundaryRect.left : viewportPadding;
    const maxBoundaryRight = boundaryRect ? boundaryRect.right : viewportWidth - viewportPadding;
    const minLeft = Math.max(viewportPadding, minBoundaryLeft);
    const maxLeft = Math.min(viewportWidth - viewportPadding, maxBoundaryRight) - displayRect.width;
    const viewportLeft = Math.max(minLeft, Math.min(disclosureRect.left, maxLeft));
    const localLeft = viewportLeft - disclosureRect.left;

    display.style.setProperty('left', `${Math.round(localLeft)}px`, 'important');
  });
}

function scheduleFacetDisplayAlignment(root = document) {
  requestAnimationFrame(() => {
    alignOpenFacetDisplays(root);
    requestAnimationFrame(() => alignOpenFacetDisplays(root));
  });
}

document.addEventListener('DOMContentLoaded', () => {
  sortSizeFacetValues();
  initFacetOverflow();
  alignOpenFacetDisplays();
});

document.addEventListener('click', (event) => {
  const target = event.target;
  if (!(target instanceof Element)) return;

  const disclosure = target.closest('#FacetFiltersForm .facets__disclosure');
  if (disclosure || target.closest('.facets__mehr-filter-btn')) {
    scheduleFacetDisplayAlignment(disclosure || document);
  }
});

document.addEventListener('toggle', (event) => {
  if (event.target.open) {
    sortClosestSizeFacet(event.target);
    scheduleFacetDisplayAlignment(event.target);
  }
}, true);

window.addEventListener(
  'resize',
  debounce(() => {
    initFacetOverflow();
    alignOpenFacetDisplays();
  }, 150)
);

class PriceRange extends HTMLElement {
  constructor() {
    super();

    this.querySelectorAll('input').forEach((element) => {
      element.addEventListener('change', this.onRangeChange.bind(this));
      element.addEventListener('keydown', this.onKeyDown.bind(this));
    });

    this.setMinAndMaxValues();
  }

  onRangeChange(event) {
    this.adjustToValidValues(event.currentTarget);
    this.setMinAndMaxValues();
  }

  onKeyDown(event) {
    if (event.metaKey) return;

    const pattern = /[0-9]|\.|,|'| |Tab|Backspace|Enter|ArrowUp|ArrowDown|ArrowLeft|ArrowRight|Delete|Escape/;
    if (!event.key.match(pattern)) event.preventDefault();
  }

  setMinAndMaxValues() {
    const inputs = this.querySelectorAll('input');
    const minInput = inputs[0];
    const maxInput = inputs[1];

    if (!minInput || !maxInput) return;

    if (maxInput.value) minInput.setAttribute('data-max', maxInput.value);
    if (minInput.value) maxInput.setAttribute('data-min', minInput.value);
    if (minInput.value === '') maxInput.setAttribute('data-min', 0);
    if (maxInput.value === '') minInput.setAttribute('data-max', maxInput.getAttribute('data-max'));
  }

  adjustToValidValues(input) {
    const value = Number(input.value);
    const min = Number(input.getAttribute('data-min'));
    const max = Number(input.getAttribute('data-max'));

    if (value < min) input.value = min;
    if (value > max) input.value = max;
  }
}

if (!customElements.get('price-range')) {
  customElements.define('price-range', PriceRange);
}

class FacetRemove extends HTMLElement {
  constructor() {
    super();

    const facetLink = this.querySelector('a');
    if (!facetLink) return;

    facetLink.setAttribute('role', 'button');
    facetLink.addEventListener('click', this.closeFilter.bind(this));
    facetLink.addEventListener('keyup', (event) => {
      event.preventDefault();
      if (event.code.toUpperCase() === 'SPACE') this.closeFilter(event);
    });
  }

  closeFilter(event) {
    event.preventDefault();

    const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
    if (form && typeof form.onActiveFilterClick === 'function') {
      form.onActiveFilterClick(event);
    }
  }
}

if (!customElements.get('facet-remove')) {
  customElements.define('facet-remove', FacetRemove);
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => initMobileSortToggles());
} else {
  initMobileSortToggles();
}

document.addEventListener('shopify:section:load', (event) => {
  initMobileSortToggles(event.target);
});
